import { z } from "zod";

import { INVALID_OPTION_MESSAGE, MIN_LENGTH_MESSAGE } from "@/utils";

/** Formulário de campanha na listagem e no sheet de edição: apenas dados básicos (Meta fica no disparo / detalhes). */
export const campaignsFormSchema = z.object({
  name: z.string().min(1, { message: MIN_LENGTH_MESSAGE("1") }),
  project_id: z.string().uuid({ message: INVALID_OPTION_MESSAGE }),
  plan_ids: z
    .array(z.string().uuid({ message: INVALID_OPTION_MESSAGE }))
    .min(1, { message: INVALID_OPTION_MESSAGE }),
  channel: z.enum(["whatsapp"]),
  status: z.enum(["draft", "active", "paused"], {
    message: INVALID_OPTION_MESSAGE,
  }),
  organization_id: z
    .string()
    .uuid({ message: INVALID_OPTION_MESSAGE })
    .optional(),
});

export type TCampaignsFormData = z.infer<typeof campaignsFormSchema>;

export const createCampaignWhatsappDispatchFormSchema = () =>
  z.object({
    whatsapp_meta_config_id: z
      .string()
      .uuid({ message: INVALID_OPTION_MESSAGE }),
    whatsapp_meta_organization_id: z.string().optional().default(""),
    whatsapp_sender_phone_number_id: z
      .string()
      .min(1, { message: MIN_LENGTH_MESSAGE("1") }),
    whatsapp_template_name: z
      .string()
      .min(1, { message: MIN_LENGTH_MESSAGE("1") }),
    whatsapp_template_language: z
      .string()
      .min(1, { message: MIN_LENGTH_MESSAGE("1") }),
    whatsapp_template_body_params_lines: z.string().optional().default(""),
  });

export type TCampaignWhatsappDispatchFormData = z.infer<
  ReturnType<typeof createCampaignWhatsappDispatchFormSchema>
>;
